const DownloadCloudIcon = () => {
  return (
    <svg height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 11.8 11 H 11.5 V 10 H 11.8 C 13 10.1 14 9.1 14.1 7.8 C 14.1 6.6 13.2 5.5 11.9 5.5 H 11.5 L 11.4 5.1 C 11.2 3.3 9.7 2 8 2 C 6.2 2 4.7 3.3 4.5 5.1 L 4.5 5.5 H 4.1 C 2.8 5.5 1.9 6.6 1.9 7.8 C 2 9.1 3 10.1 4.3 10 H 4.5 V 11 H 4.3 C 2.6 11 1.2 9.7 1 8.1 C 0.9 6.4 2 4.9 3.6 4.6 C 4 2.5 5.9 1 8 1 C 10.1 1 12 2.5 12.4 4.6 C 14 4.9 15.1 6.4 15 8.1 C 14.8 9.7 13.4 11 11.8 11 Z M 8.5 13.1 V 7 H 7.5 V 13.1 L 6.2 11.8 L 5.5 12.5 L 8 15 L 10.5 12.5 L 9.8 11.8 L 8.5 13.1 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default DownloadCloudIcon;
